import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { LanguageContext } from './LanguageContext';
import { RiMessage3Line, RiUserStarLine } from 'react-icons/ri';
import { MdOutlineLocalShipping, MdOutlineCategory, MdTableBar, MdOutlineAmpStories } from 'react-icons/md';
import { HiUsers } from 'react-icons/hi';
import { SiFigshare } from 'react-icons/si';
import { GoDeviceMobile } from 'react-icons/go';
import { BiHomeAlt, BiSupport } from 'react-icons/bi';
import { MdOutlineSubscriptions } from 'react-icons/md';
import { BsWindow, BsLayoutTextSidebarReverse, BsFillCollectionFill } from 'react-icons/bs';
import { FaRegChartBar, FaMoneyCheck, FaUserCog, FaUserLock, FaBoxes, FaShippingFast, FaCalculator } from 'react-icons/fa';
import { AiOutlineShopping, AiOutlineTag, AiOutlineInbox, AiOutlineMobile } from 'react-icons/ai';
import { GiPieChart } from 'react-icons/gi';
import sidenavstyles from './components/Dashboard/Sidenavfiles/sidenav.module.css';
import { TbShoppingCartExclamation } from 'react-icons/tb';
import { GrTransaction } from 'react-icons/gr';

export const Contexthandlerscontext = React.createContext();
export const Contexthandlerscontext_provider = (props) => {
    let history = useHistory();
    const { lang, setlang, langdetect } = React.useContext(LanguageContext);
    const setroutedispatcherfunccontext = (route) => {
        history.push(route);
    };

    const buildSidenavArray = (lang) => [
        {
            maintitle: lang.sidenav_dashboards,
            auth: ['instowner', 'inststuff'],
            subitems: [
                {
                    subtitlename: lang.sidenav_home,
                    auth: ['instowner', 'inststuff'],
                    isselected: false,
                    reactpath: '/dashboard/institute/home',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <BiHomeAlt />
                        </i>
                    ),
                },
                {
                    subtitlename: lang.sidenav_pos,
                    auth: ['instowner', 'inststuff'],
                    isselected: false,
                    reactpath: '/dashboard/institute/POSHome/all/all',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <FaCalculator />
                        </i>
                    ),
                },
                {
                    subtitlename: lang.support,
                    auth: ['instowner', 'inststuff'],
                    isselected: false,
                    reactpath: '/dashboard/institute/support',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <BiSupport />
                        </i>
                    ),
                },
                {
                    subtitlename: lang.sidenav_reports,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/reports',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <GiPieChart />
                        </i>
                    ),
                },
            ],
        },
        {
            maintitle: lang.sidenav_orders,
            auth: ['instowner', 'inststuff'],
            subitems: [
                {
                    subtitlename: lang.sidenav_orders,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/orders',
                    icon: (
                        <span>
                            <i class={sidenavstyles.metismenu_icon}>
                                <AiOutlineShopping size={18} />
                            </i>
                        </span>
                    ),
                },
                {
                    subtitlename: lang.sidenav_orderstracking,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/orders/ordertracking',
                    icon: (
                        <span>
                            <i class={sidenavstyles.metismenu_icon}>
                                <GrTransaction size={18} />
                            </i>
                        </span>
                    ),
                },
                {
                    subtitlename: lang.sidenav_abandonedcarts,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/abandonedcarts',
                    icon: (
                        <span>
                            <i class={sidenavstyles.metismenu_icon}>
                                <TbShoppingCartExclamation size={18} />
                            </i>
                        </span>
                    ),
                },
                // {
                //     subtitlename: lang.sidenav_reservations,
                //     isselected: false,
                //     auth: ['instowner', 'inststuff'],
                //     reactpath: '/dashboard/institute/reservations',
                //     icon: (
                //         <span>
                //             <i class={sidenavstyles.metismenu_icon}>
                //                 <AiOutlineShopping size={18} />
                //             </i>
                //         </span>
                //     ),
                // },
                {
                    subtitlename: lang.sidenav_promocodes,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/promocodes',
                    icon: <i class={sidenavstyles.metismenu_icon + ' bx bx-bookmarks '}></i>,
                },
                {
                    subtitlename: lang.sidenav_customers,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/customers',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <RiUserStarLine />
                        </i>
                    ),
                },
            ],
        },
        {
            maintitle: lang.sidenav_products,
            auth: ['instowner', 'inststuff'],
            subitems: [
                {
                    subtitlename: lang.sidenav_subscriptionscustomers,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/institutesubscriptionspackages/0',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <MdOutlineSubscriptions size={18} />
                        </i>
                    ),
                },
                {
                    subtitlename: lang.tables,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/tables',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <MdTableBar size={18} />
                        </i>
                    ),
                },
                {
                    subtitlename: lang.sidenav_products,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/products/all/0',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <AiOutlineTag size={18} />
                        </i>
                    ),
                },
                {
                    subtitlename: lang.sidenav_collections,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/collections',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <AiOutlineInbox size={18} />
                        </i>
                    ),
                },
                {
                    subtitlename: lang.parentcollections,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/parentcollections',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <BsFillCollectionFill size={18} />
                        </i>
                    ),
                },
                {
                    subtitlename: lang.categories,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/categories',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <MdOutlineCategory size={18} />
                        </i>
                    ),
                },
            ],
        },
        {
            maintitle: lang.sidenav_management,
            auth: ['instowner', 'inststuff'],
            subitems: [
                // {
                //     subtitlename: lang.sidenav_branches,
                //     isselected: false,
                //     auth: ['instowner', 'inststuff'],
                //     reactpath: '/dashboard/institute/branches',
                //     icon: (
                //         <i class={sidenavstyles.metismenu_icon}>
                //             <HiOutlineOfficeBuilding size={18} />
                //         </i>
                //     ),
                // },
                {
                    subtitlename: lang.sidenav_affiliates,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/affiliates',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <SiFigshare />
                        </i>
                    ),
                },
                {
                    subtitlename: lang.sidenav_users,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/users',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <HiUsers />
                        </i>
                    ),
                },
                {
                    subtitlename: lang.sidenav_vendors,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/vendors',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <FaBoxes />
                        </i>
                    ),
                },
                // {
                //     subtitlename: lang.sidenav_mobileapplication,
                //     auth: ['instowner', 'inststuff'],
                //     isselected: false,
                //     reactpath: '/dashboard/institute/mobileapplication',
                //     icon: (
                //         <i class={sidenavstyles.metismenu_icon}>
                //             <GoDeviceMobile />
                //         </i>
                //     ),
                // },
            ],
        },
        {
            maintitle: lang.sidenav_design,
            auth: ['instowner', 'inststuff'],
            subitems: [
                {
                    subtitlename: lang.sidenav_websitetemplates,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/websitetempates',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <BsWindow />
                        </i>
                    ),
                },
                {
                    subtitlename: lang.sidenav_mobileapptemplates,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/mobiletemplates',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <AiOutlineMobile />
                        </i>
                    ),
                },
            ],
        },

        {
            maintitle: lang.sidenav_onlinestore,
            auth: ['instowner', 'inststuff'],
            subitems: [
                {
                    subtitlename: lang.sidenav_shipping,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/Shipping',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <MdOutlineLocalShipping />
                        </i>
                    ),
                },
                {
                    subtitlename: lang.sidenav_couriers,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/couriers',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <FaShippingFast />
                        </i>
                    ),
                },
                {
                    subtitlename: lang.sidenav_onlinepayment,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/payment',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <FaMoneyCheck />
                        </i>
                    ),
                },
                {
                    subtitlename: lang.sidenav_onlinegeneralpayments,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/generalpayments',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <FaMoneyCheck />
                        </i>
                    ),
                },
                {
                    subtitlename: lang.sidenav_policies,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/policies',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <BsLayoutTextSidebarReverse />
                        </i>
                    ),
                },
            ],
        },
        {
            maintitle: lang.sidenav_settings,
            auth: ['instowner', 'inststuff'],
            subitems: [
                {
                    subtitlename: lang.dynamicforms,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/dynamicforms',
                    icon: <i class={sidenavstyles.metismenu_icon + ' bx bx-edit '}></i>,
                },
                {
                    subtitlename: lang.sidenav_institutesettings,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/instsettings',
                    icon: <i class={sidenavstyles.metismenu_icon + ' bx bx-cog '}></i>,
                },
                {
                    subtitlename: lang.sidenav_generalsettings,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/generalsettings',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <FaUserCog class="h-100" />
                        </i>
                    ),
                },
                {
                    subtitlename: lang.sidenav_securitylayers,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/securitylayers',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <FaUserLock />
                        </i>
                    ),
                },
                {
                    subtitlename: lang.sidnav_subscription,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/subscription',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <RiMessage3Line />
                        </i>
                    ),
                },
                // {
                //     subtitlename: lang.sidenav_smsservice,
                //     isselected: false,
                //     auth: ['instowner', 'inststuff'],
                //     reactpath: '/dashboard/institute/smsservice',
                //     icon: (
                //         <i class={sidenavstyles.metismenu_icon}>
                //             <RiMessage3Line />
                //         </i>
                //     ),
                // },
                // {
                //     subtitlename: lang.sidenav_integrations,
                //     isselected: false,
                //     auth: ['instowner', 'inststuff'],
                //     reactpath: '/dashboard/institute/integrations',
                //     icon: (
                //         <i class={sidenavstyles.metismenu_icon}>
                //             <RiMessage3Line />
                //         </i>
                //     ),
                // },
                {
                    subtitlename: lang.sidenav_stories,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/stories',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <MdOutlineAmpStories />
                        </i>
                    ),
                },
                {
                    subtitlename: lang.smintegrations,
                    isselected: false,
                    auth: ['instowner', 'inststuff'],
                    reactpath: '/dashboard/institute/analytics',
                    icon: (
                        <i class={sidenavstyles.metismenu_icon}>
                            <FaRegChartBar />
                        </i>
                    ),
                },
            ],
        },
        {
            maintitle: 'Tabex Admin Mangement',
            auth: ['tabexadmin'],
            subitems: [
                {
                    subtitlename: 'Institutes',
                    isselected: false,
                    auth: ['tabexadmin'],
                    reactpath: '/dashboard/institute/tabexadmin/institutes',
                    icon: <i class={sidenavstyles.metismenu_icon + ' bx bx-cog '}></i>,
                },
                {
                    subtitlename: 'Users Dashboard',
                    isselected: false,
                    auth: ['tabexadmin'],
                    reactpath: '/dashboard/institute/tabexadmin/users',
                    icon: <i class={sidenavstyles.metismenu_icon + ' bx bx-cog '}></i>,
                },
            ],
        },
    ];
    const applyPreviousState = (nextArr, prevArr) => {
        const subitemByPath = new Map();
        prevArr.forEach((sideelement) => {
            sideelement.subitems.forEach((subsideelement) => {
                if (subsideelement.reactpath) {
                    subitemByPath.set(subsideelement.reactpath, subsideelement);
                }
            });
        });

        nextArr.forEach((sideelement, idx) => {
            const prevMain = prevArr[idx];
            if (prevMain && typeof prevMain.ismainpagepermssionaccess !== 'undefined') {
                sideelement.ismainpagepermssionaccess = prevMain.ismainpagepermssionaccess;
            }
            sideelement.subitems.forEach((subsideelement) => {
                const prevSub = subitemByPath.get(subsideelement.reactpath);
                if (prevSub) {
                    subsideelement.isselected = prevSub.isselected;
                    subsideelement.issubpagepermssionaccess = prevSub.issubpagepermssionaccess;
                }
            });
        });

        return nextArr;
    };

    const [sidenavarray_context, setsidenavarray_context] = useState(() => buildSidenavArray(lang));
    const [pagetitle_context, setpagetitle_context] = useState('');
    const setsidenavactive_context = (route) => {
        var temparr = [...sidenavarray_context];
        temparr.forEach((sideelement, index) => {
            sideelement.subitems.forEach((subsideelement, index) => {
                if (subsideelement.reactpath == route) {
                    subsideelement['isselected'] = true;
                } else {
                    subsideelement['isselected'] = false;
                }
            });
        });

        setsidenavarray_context([...temparr]);
    };
    useEffect(() => {
        setsidenavarray_context((prev) => {
            const next = buildSidenavArray(lang);
            return applyPreviousState(next, prev);
        });
    }, [lang]);
    const languageConfigs = [
        { suffix: 'es', title: lang.spanish, instAttr: 'es_lang' },
        { suffix: 'nrwig', title: lang.norwegian, instAttr: 'nrwig_lang' },
        { suffix: 'dut', title: lang.dutch, instAttr: 'dut_lang' },
        { suffix: 'chin', title: lang.chinese, instAttr: 'chine_lang' },
        { suffix: 'fr', title: lang.french, instAttr: 'french_lang' },
        { suffix: 'germ', title: lang.german, instAttr: 'germ_lang' },
        { suffix: 'turk', title: lang.turkish, instAttr: 'turk_lang' },
        { suffix: 'magr', title: lang.hungarian, instAttr: 'magr_lang' },
        { suffix: 'ital', title: lang.italian, instAttr: 'ital_lang' },
        { suffix: 'rus', title: lang.russian, instAttr: 'russian_lang' },
    ];

    return (
        <Contexthandlerscontext.Provider
            value={{
                sidenavarray_context,
                setsidenavarray_context,
                pagetitle_context,
                setpagetitle_context,
                setsidenavactive_context,
                languageConfigs,
            }}
        >
            {props.children}
        </Contexthandlerscontext.Provider>
    );
};
